export const hasPermission = (permissionKey) => {
  const role = localStorage.getItem("usertype");

  // Admin has everything
  if (role === "admin") return true;

  const permissions = JSON.parse(
    localStorage.getItem("permissions") || "{}"
  );

  return permissions[permissionKey] === true;
};
